import {
  Accordion as SemanticAccordion,
  Button,
  Checkbox,
  Container,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Input,
  Label as SemanticLabel,
  List,
  Loader,
  Menu as SemanticMenu,
  Message,
  Modal,
  Pagination,
  Placeholder,
  Popup,
  Radio,
  Rating,
  Segment,
  Sidebar,
  SidebarPushable,
  SidebarPusher,
  Tab,
  Table,
} from "semantic-ui-react";

export {
  Button,
  Checkbox,
  Container,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Input,
  List,
  Loader,
  Message,
  Modal,
  Pagination,
  Placeholder,
  Popup,
  Radio,
  Rating,
  Segment,
  Sidebar,
  SidebarPushable,
  SidebarPusher,
  Tab,
  Table,
};

export const Accordion = SemanticAccordion;
export const AccordionTitle = SemanticAccordion.Title;
export const AccordionContent = SemanticAccordion.Content;

export const Menu = SemanticMenu;
export const MenuItem = SemanticMenu.Item;

export const Label = SemanticLabel;
export const LabelDetail = SemanticLabel.Detail;

export const PlaceholderLine = Placeholder.Line;
export const PlaceholderImage = Placeholder.Image;

export const TextArea = Form.TextArea;
